import React, { useState, useEffect } from "react";
import { useStyles } from "./ServiceOverviewStyle";
import FrameImg from "../../assets/icons/FrameImg.png";
import shutDown from "../../assets/icons/shutDown.png";
import DeleteIcon from "@material-ui/icons/Delete";
import serviceName from "../../assets/icons/serviceName.png";
import serviceTime from "../../assets/icons/serviceTime.png";
import serviceCalender from "../../assets/icons/serviceCalender.png";
import nodes from "../../assets/icons/nodes.png";

import AppBar from '@material-ui/core/AppBar';
import { colors } from '../../constants/colors/Colors';
import { Button } from '@material-ui/core';
import Metrics from './metrics/Metrics';
import Overview from "../../components/serviceOverviewTabs/overview/Overview";
import Network from './network/Network';
import Logs from './logs/Logs';
import Users from './users/Users';
import ACL from './acl/ACL';
import Connector from './connector/Connector';
import Schema from './schema/Schema';
import UseServiceOverview from './UseServiceOverview';
import Topics from './topics/Topics';
export default function ServiceOverview() {
  const [value, setValue] = React.useState(0);
  const [{ userTableHeadings, aclTableHeadings, aclData,size }] = UseServiceOverview();
  const classes = useStyles();
  return (
    <div
      style={{ width: size.width < 960 ? "100%" : size.width - 330 }}
    >
      <div className={classes.headServiceOverview}>
        <div className={classes.headServiceOverviewContainer}>
          <div className={classes.headServiceOverviewLeft}>
            <img src={FrameImg} width={42} height={41} alt="img" />
            <div className={classes.leftHead}>
              <p className={classes.serviceText}>{"Kafka-17df67d9"}</p>
              <div className={classes.serviceInnerText}>
                <div className={classes.serviceInnerWhiteDiv}>
                  <img
                    src={serviceName}
                    width={10}
                    height={10}
                    style={{ marginRight: 5 }}
                    alt="img"
                  />
                  <p className={classes.text}>{"Apache kafka 3.1"}</p>
                </div>
                <div className={classes.serviceInnerWhiteDiv}>
                  <img
                    src={serviceCalender}
                    width={10}
                    height={10}
                    style={{ marginRight: 5 }}
                    alt="img"
                  />
                  <p className={classes.text}>{"EOL : 2023-01-25 : OK"}</p>
                </div>
                <div className={classes.serviceInnerWhiteDiv}>
                  <img
                    src={serviceTime}
                    width={10}
                    height={10}
                    style={{ marginRight: 5 }}
                    alt="img"
                  />
                  <p className={classes.text}>{"Rebuilding"}</p>
                </div>
                <div className={classes.serviceInnerWhiteDiv}>
                  <img
                    src={nodes}
                    width={10}
                    height={10}
                    style={{ marginRight: 5 }}
                    alt="img"
                  />
                  <p className={classes.text}>{"Nodes"} </p>
                  <div className={classes.dot} />
                  <div className={classes.dot} />
                  <div className={classes.dot} />
                </div>
              </div>
            </div>
          </div>

          <div className={classes.btnContainer}>
            <Button
              variant="outlined"
              disableRipple={true}
              size={"small"}
              startIcon={
                <DeleteIcon
                  fontSize="large"
                  style={{ color: "#5B6773", marginRight: -5 }}
                />
              }
              className={classes.headBtn}
              classes={{ root: classes.btnRoot }}
            >
              Delete service
            </Button>
            <div
              style={{ borderRight: "1px solid #D4DDE4", marginRight: 18 }}
            />
            <Button
              variant="outlined"
              disableRipple={true}
              startIcon={
                <img src={shutDown} alt="img" width={18} height={18} />
              }
              className={classes.headBtn}
              classes={{ root: classes.btnRoot }}
            >
              Power off service
            </Button>
          </div>
        </div>
      </div>

      <div className={classes.root}>
        <AppBar
          elevation={0}
          position="static"
          color="default"
          className={classes.appBar}
        >
          <div className={"tabsRow"}>
            <div
              onClick={() => setValue(0)}
              className={value === 0 ? classes.selected : classes.notSelected}
            >
              <p className={value !== 0 ? classes.tabHead : classes.activeTab}>
                Overview
              </p>
            </div>
            <div
              onClick={() => setValue(1)}
              className={value === 1 ? classes.selected : classes.notSelected}
            >
              <p className={value !== 1 ? classes.tabHead : classes.activeTab}>
                Network
              </p>
            </div>
            <div
              onClick={() => setValue(2)}
              className={value === 2 ? classes.selected : classes.notSelected}
            >
              <p className={value !== 2 ? classes.tabHead : classes.activeTab}>
                Metrics
              </p>
            </div>
            <div
              onClick={() => setValue(3)}
              className={value === 3 ? classes.selected : classes.notSelected}
            >
              <p className={value !== 3 ? classes.tabHead : classes.activeTab}>
                Logs
              </p>
            </div>
            <div
              onClick={() => setValue(4)}
              className={value === 4 ? classes.selected : classes.notSelected}
            >
              <p className={value !== 4 ? classes.tabHead : classes.activeTab}>
                Users
              </p>
            </div>
            <div
              onClick={() => setValue(5)}
              className={value === 5 ? classes.selected : classes.notSelected}
            >
              <p className={value !== 5 ? classes.tabHead : classes.activeTab}>
                ACL
              </p>
            </div>
            <div
              onClick={() => setValue(6)}
              className={value === 6 ? classes.selected : classes.notSelected}
            >
              <p className={value !== 6 ? classes.tabHead : classes.activeTab}>
                Topics
              </p>
            </div>
            <div
              onClick={() => setValue(7)}
              className={value === 7 ? classes.selected : classes.notSelected}
            >
              <p className={value !== 7 ? classes.tabHead : classes.activeTab}>
                Connectors
              </p>
            </div>
            <div
              onClick={() => setValue(8)}
              className={value === 8 ? classes.selected : classes.notSelected}
            >
              <p className={value !== 8 ? classes.tabHead : classes.activeTab}>
                Schemas
              </p>
            </div>
          </div>
        </AppBar>
        {value === 0 ? (
          <div className={classes.tabsBodyContainer}>
            <Overview />
          </div>
        ) : value === 1 ? (
          <div className={classes.tabsBodyContainer}>
            <Network />
          </div>
        ) : value == 2 ? (
          <div className={classes.tabsBodyContainer}>
            <Metrics />
          </div>
        ) : value == 3 ? (
          <div className={classes.tabsBodyContainer}>
            <Logs />
          </div>
        ) : value == 4 ? (
          <div className={classes.tabsBodyContainer}>
            <Users headings={userTableHeadings} />
          </div>
        ) : value == 5 ? (
          <div className={classes.tabsBodyContainer}>
            <ACL headings={aclTableHeadings} data={aclData} />
          </div>
        )
          : value == 6 ? (
            <div className={classes.tabsBodyContainer}>
              <Topics />
            </div>
          ) : value == 7 ? (
            <div className={classes.tabsBodyContainer}>
              <Connector />
            </div>
          ) : value == 8 ? (
            <div className={classes.tabsBodyContainer}>
              <Schema />
            </div>
          ) : null}
      </div>
    </div>
  );
}
